;(function() {
  'use strict'

  Surveys.$inject = ["$scope", "$state", "glError", "surveyStreamService"];
  angular.module('app.surveys').controller('Surveys', Surveys)

  /* @ngInject */
  function Surveys($scope, $state, glError, surveyStreamService) {
    $scope.goToSurvey = goToSurvey

    $scope.surveys = surveyStreamService
    $scope.surveys.promise.then(angular.noop, glError.fromStatus)

    /**
     * @name goToSurvey
     * @desc go to a survey
     * @param {String} surveyId the survey id
     */
    function goToSurvey(surveyId) {
      $state.go('app.survey', { id: surveyId })
    }
  }
})()
